import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { 
  Phone, 
  MapPin, 
  ChevronDown, 
  ChevronUp,
  Building2,
  CheckCircle,
  Star,
  MessageCircle,
  Clock,
  Users,
  FileText,
  Shield,
  Heart,
  ArrowRight,
  Home,
  ChevronRight,
  ExternalLink,
  Mail
} from "lucide-react";
import { Header, Footer } from "../components/Layout";
import CentersByLocationLinks from "../components/seo/CentersByLocationLinks";

import { API } from '../utils/api';
// API imported from utils/api

// Helper function to get the correct image URL
function getImageUrl(url) {
  if (!url) return null;
  if (url.includes('.emergent.host/api/') || url.includes('.emergentagent.com/api/')) {
    try { url = new URL(url).pathname; } catch(e) {}
  }
  if (url.startsWith('/api/')) {
    var base = process.env.REACT_APP_BACKEND_URL;
    if (base && !base.includes('localhost') && typeof window !== 'undefined' && !base.includes(window.location.hostname)) {
      base = window.location.origin;
    }
    return (base || '') + url;
  }
  return url;
}

// Accordion component for dropdown info
const InfoAccordion = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return (
    <div className="border border-slate-700 rounded-xl overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 flex items-center justify-between bg-slate-800/50 hover:bg-slate-800 transition-colors text-left"
      >
        <span className="font-semibold text-white">{title}</span>
        {isOpen ? (
          <ChevronUp className="w-5 h-5 text-emerald-400" />
        ) : (
          <ChevronDown className="w-5 h-5 text-emerald-400" />
        )}
      </button>
      {isOpen && (
        <div className="px-6 py-4 bg-slate-900/50 text-slate-300">
          {children}
        </div>
      )}
    </div>
  );
};

const CentrosRehabilitacionDrogasGratisLanding = () => {
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAllRegionales, setShowAllRegionales] = useState(false);
  const [showAllPreviene, setShowAllPreviene] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState('todas');

  // Direcciones Regionales SENDA
  const direccionesRegionales = [
    { region: "Arica y Parinacota", direccion: "Magallanes 1631, Arica", telefono: "58223773", email: "karla.escriba@senda.gob.cl", director: "Jorge Cannobbio Santos" },
    { region: "Tarapacá", direccion: "Orella 201, Iquique", telefono: "572429355", email: "ihidalgo@senda.gob.cl", director: "Alejandra Zúñiga Ponce" },
    { region: "Antofagasta", direccion: "Almirante Latorre 2042, Antofagasta", telefono: "552498060", email: "jimena.herrera@senda.gob.cl", director: "Néstor Maizares del Pino" },
    { region: "Atacama", direccion: "Chacabuco 681, of. 801, Copiapó", telefono: "52-2233037", email: null, director: "Martha Palma Pizarro" },
    { region: "Coquimbo", direccion: "Gabriel González Videla N°2512, La Serena", telefono: "51223430", email: "jose.huerta@senda.gob.cl", director: "Rodrigo Maturana Villarroel" },
    { region: "Valparaíso", direccion: "Condell 1231, piso 6°, Valparaíso", telefono: "32 2599580", email: "paula.osorio@senda.gob.cl", director: "Carlos Colihuechun Brevis" },
    { region: "Metropolitana", direccion: "Ahumada 370, piso 8, Santiago", telefono: "225100900", email: "varlenka.olivares@senda.gob.cl", director: "Eduardo Barros Ronda" },
    { region: "O'Higgins", direccion: "Gamero 018, Rancagua", telefono: "72 2222343", email: "ian.ellicker@senda.gob.cl", director: "Carlos Leyton Verdugo" },
    { region: "Maule", direccion: "4 Oriente 1490, Talca", telefono: "71-2215356", email: "milton.saavedra@senda.gob.cl", director: "Ana María Rodríguez" },
    { region: "Ñuble", direccion: "Carrera 409, Chillán", telefono: "42 2268900", email: "claudio.gonzalez@senda.gob.cl", director: "Luisa Contreras Torres" },
    { region: "Biobío", direccion: "San Martín N°290, Concepción", telefono: "412521911", email: "tatiana.aspe@senda.gob.cl", director: "Bayron Martínez Ulloa" },
    { region: "La Araucanía", direccion: "Prat 620, of. 301, Temuco", telefono: "452212220", email: "natalia.campos@senda.gob.cl", director: "Lissy Cerda Muñoz" },
    { region: "Los Ríos", direccion: "Carlos Anwandter Nº313, Valdivia", telefono: "63253716", email: "veronica.conejeros@senda.gob.cl", director: "Cinthia Lara Loyola" },
    { region: "Los Lagos", direccion: "Juan Soler Manfredini 41, Of.1102, Puerto Montt", telefono: "652344606", email: "ccarcamo@senda.gob.cl", director: "Maritza Canobra Mancilla" },
    { region: "Aysén", direccion: "Riquelme 334, Coyhaique", telefono: "67251025", email: "silvana.henriquez@senda.gob.cl", director: "María Victoria Contreras" },
    { region: "Magallanes", direccion: "Sarmiento 845, Punta Arenas", telefono: "612244484", email: "maria.ruiz@senda.gob.cl", director: "Roxana Arancibia" },
  ];

  // Oficinas SENDA Previene
  const oficinasPreviene = [
    { comuna: "Arica", region: "Arica y Parinacota", direccion: "18 de Septiembre esq. Pedro Montt", telefono: "582386718", email: "previene.arica@gmail.com" },
    { comuna: "Iquique", region: "Tarapacá", direccion: "Esmeralda 768", telefono: "942193384", email: "csolar@municipioiquique.cl" },
    { comuna: "Antofagasta", region: "Antofagasta", direccion: "Calle Prat 921", telefono: "552887720", email: "senda.previene@imantof.cl" },
    { comuna: "Calama", region: "Antofagasta", direccion: "Pje. Monseñor J.B. Herrada 1682", telefono: "552892686", email: "sendapreviene@municipalidadcalama.cl" },
    { comuna: "Copiapó", region: "Atacama", direccion: "Juan Serapio Lois 849", telefono: "987683679", email: "previenecopiapo@gmail.com" },
    { comuna: "La Serena", region: "Coquimbo", direccion: "Brasil 416", telefono: "512206569", email: "eduardo.rodriguez@laserena.cl" },
    { comuna: "Valparaíso", region: "Valparaíso", direccion: "Eleuterio Ramírez 476, piso 7", telefono: "322939236", email: "camila.trujillo@munivalpo.cl" },
    { comuna: "Viña del Mar", region: "Valparaíso", direccion: "Plaza Vergara S/N", telefono: "322184700", email: "senda.previene@munivina.cl" },
    { comuna: "Santiago", region: "Metropolitana", direccion: "Hurtado Rodriguez 319", telefono: "224897430", email: "previenestgo@gmail.com" },
    { comuna: "Maipú", region: "Metropolitana", direccion: "Corregidor Zañartu 1706", telefono: "224028261", email: "previenemaipu@gmail.com" },
    { comuna: "Puente Alto", region: "Metropolitana", direccion: "Eyzaguirre 1120", telefono: "227315492", email: "yolanda.carrera@mpuentealto.cl" },
    { comuna: "La Florida", region: "Metropolitana", direccion: "Marigen 9638", telefono: "225054290", email: "sendaprevienelaflorida2014@gmail.com" },
    { comuna: "Las Condes", region: "Metropolitana", direccion: "Diaguitas 911", telefono: "229507676", email: "senda@lascondes.cl" },
    { comuna: "Providencia", region: "Metropolitana", direccion: "Av. Pedro de Valdivia 963", telefono: "227067059", email: "sendapreviene@cdsprovidencia.cl" },
    { comuna: "Rancagua", region: "O'Higgins", direccion: "Gamero 080", telefono: "722203404", email: "sendaprevienerancagua@gmail.com" },
    { comuna: "Talca", region: "Maule", direccion: "4 Poniente 1239", telefono: null, email: "previene@talca.cl" },
    { comuna: "Chillán", region: "Ñuble", direccion: "Claudio Arrau 718", telefono: "422430477", email: "sendachillan@gmail.com" },
    { comuna: "Concepción", region: "Biobío", direccion: "Lincoyán 248", telefono: "412263087", email: "previeneimconcepcion@gmail.com" },
    { comuna: "Los Ángeles", region: "Biobío", direccion: "Dario Barrueto 260", telefono: "432322222", email: "sendalosangeles@gmail.com" },
    { comuna: "Temuco", region: "La Araucanía", direccion: "Andrés Bello 510", telefono: "452973122", email: "previene@temuco.cl" },
    { comuna: "Valdivia", region: "Los Ríos", direccion: "Los Laureles 410", telefono: "632220320", email: "coordinacionprevienevaldivia@gmail.com" },
    { comuna: "Puerto Montt", region: "Los Lagos", direccion: "Benavente 511, 5° piso", telefono: null, email: "previenepuertomontt@gmail.com" },
    { comuna: "Osorno", region: "Los Lagos", direccion: "Conrado Amtauer 933", telefono: "642218720", email: "sendaosorno@gmail.com" },
    { comuna: "Coyhaique", region: "Aysén", direccion: "Errazuriz 532", telefono: "672213171", email: "sendaprevienecoyhaique@gmail.com" },
    { comuna: "Punta Arenas", region: "Magallanes", direccion: "Bories 901, Piso 5", telefono: null, email: "coordinadorsendapreviene@gmail.com" },
  ];

  const regiones = ['todas', ...new Set(oficinasPreviene.map(o => o.region))];
  const filteredPreviene = selectedRegion === 'todas' 
    ? oficinasPreviene 
    : oficinasPreviene.filter(o => o.region === selectedRegion);

  useEffect(() => {
    async function loadFreeCenters() {
      try {
        // Load centers and filter for free ones (price_range contains "gratis" or low price)
        const response = await axios.get(`${API}/centers/public?limit=50`);
        const allCenters = response.data.centers || [];
        
        // Filter centers that might be free or low-cost
        const freeCenters = allCenters.filter(center => {
          const priceRange = (center.price_range || "").toLowerCase();
          const description = (center.description || "").toLowerCase();
          const name = (center.name || "").toLowerCase();
          
          return (
            priceRange.includes("gratis") ||
            priceRange.includes("gratuito") ||
            priceRange.includes("senda") ||
            priceRange.includes("fonasa") ||
            priceRange.includes("público") ||
            priceRange.includes("0") ||
            description.includes("gratuito") ||
            description.includes("senda") ||
            description.includes("fonasa") ||
            name.includes("senda") ||
            name.includes("público")
          );
        });
        
        setCenters(freeCenters.length > 0 ? freeCenters : allCenters.slice(0, 12));
      } catch (error) {
        console.error("Error loading centers:", error);
      } finally {
        setLoading(false);
      }
    }
    loadFreeCenters();
  }, []);

  // Schema.org structured data for SEO
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Centros de Rehabilitación Gratis en Chile (2026) | FONASA y SENDA",
    "description": "Directorio de centros de rehabilitación gratis en Chile financiados por SENDA y FONASA. Requisitos, cómo postular y lista actualizada por región.",
    "url": "https://sinadicciones.org/centros-de-rehabilitacion-de-drogas-gratis",
    "inLanguage": "es-CL",
    "isPartOf": {"@type": "WebSite", "name": "SinAdicciones.org", "url": "https://sinadicciones.org/"},
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": centers.slice(0, 10).map((center, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "MedicalOrganization",
          "name": center.name,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": center.city || "Chile",
            "addressRegion": center.region || "Chile",
            "addressCountry": "CL"
          },
          "medicalSpecialty": "Addiction Medicine"
        }
      }))
    }
  };

  // FAQ JSON-LD para featured snippets en Google
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "¿Qué significa 'gratis' en rehabilitación de drogas en Chile?",
        "acceptedAnswer": {"@type": "Answer", "text": "En Chile, 'gratis' significa que el tratamiento es financiado por el Estado vía SENDA (Servicio Nacional para la Prevención y Rehabilitación del Consumo de Drogas y Alcohol) y cubierto por FONASA. Está disponible para afiliados FONASA tramos A, B, C y D, además de personas sin previsión. No tiene costo para el usuario en la red de salud pública ni en los centros conveniados por SENDA."}
      },
      {
        "@type": "Question",
        "name": "¿Cuáles son los requisitos para acceder a rehabilitación gratis?",
        "acceptedAnswer": {"@type": "Answer", "text": "Necesitas: (1) ser chileno o residente, (2) estar inscrito o inscribirte en FONASA (tramo A, B, C o D — el tramo A es gratis y se obtiene rápido en cualquier CESFAM), (3) acudir a tu CESFAM o llamar al Fono Drogas y Alcohol 1412 para una evaluación inicial, y (4) aceptar el plan de tratamiento ofrecido por SENDA tras la evaluación."}
      },
      {
        "@type": "Question",
        "name": "¿Cómo postulo a un centro de rehabilitación gratis en Chile?",
        "acceptedAnswer": {"@type": "Answer", "text": "Paso 1: Llama gratis al Fono Drogas 1412 (24/7) o acude a tu CESFAM más cercano. Paso 2: Solicita una evaluación con el equipo de salud mental. Paso 3: Recibirás una derivación a un centro de la red SENDA según tu perfil (ambulatorio o residencial). Paso 4: Inicias el tratamiento. Todo el proceso es confidencial y sin costo."}
      },
      {
        "@type": "Question",
        "name": "¿Hay lista de espera para entrar a un centro gratuito?",
        "acceptedAnswer": {"@type": "Answer", "text": "En programas ambulatorios la espera suele ser corta (días o pocas semanas). En programas residenciales puede haber lista de espera de semanas o meses dependiendo de la región y el cupo disponible. SENDA prioriza casos de mayor gravedad, embarazadas, adolescentes y población vulnerable. Si estás en crisis, llama al 1412 — pueden activar una ruta de urgencia."}
      },
      {
        "@type": "Question",
        "name": "¿Qué cubre exactamente FONASA en tratamiento de adicciones?",
        "acceptedAnswer": {"@type": "Answer", "text": "FONASA cubre 100% del costo en la modalidad institucional (centros públicos y conveniados con SENDA): consultas psiquiátricas, psicoterapia individual y grupal, programas ambulatorios intensivos (PAI), residenciales de corta y larga estadía, comunidades terapéuticas para adolescentes y adultos, y atención a mujeres con hijos. No cubre centros 100% privados que no estén en convenio."}
      },
      {
        "@type": "Question",
        "name": "¿Qué hago si no califico para SENDA o FONASA?",
        "acceptedAnswer": {"@type": "Answer", "text": "Si tienes ISAPRE o no puedes acceder a SENDA, hay alternativas: (1) fundaciones y ONG sin fines de lucro como Hogar de Cristo o algunas comunidades terapéuticas cristianas, (2) centros con planes de costo reducido o becas, (3) ISAPRE: revisa tu cobertura GES y CAEC para salud mental. En sinadicciones.org tienes el directorio completo y puedes cotizar."}
      },
      {
        "@type": "Question",
        "name": "¿Cuánto dura un tratamiento gratuito de rehabilitación?",
        "acceptedAnswer": {"@type": "Answer", "text": "Depende del programa: ambulatorio básico 3-6 meses, ambulatorio intensivo (PAI) 6-9 meses, residencial 3-12 meses según severidad. Para adolescentes hay programas específicos y para mujeres embarazadas o con hijos también. La duración la define el equipo clínico, no es fija."}
      }
    ]
  };

  return (
    <div className="min-h-screen bg-slate-950">
      
        {/* Primary SEO Tags */}
        <title>Centros de Rehabilitación Gratis en Chile (2026) | FONASA y SENDA — SinAdicciones</title>
        <meta name="description" content="¿Buscas tratamiento gratis para adicciones en Chile? Centros verificados financiados por SENDA y FONASA en las 16 regiones. Requisitos, cómo postular y lista actualizada." />
        <meta name="keywords" content="centros de rehabilitación gratis Chile, rehabilitación gratis Chile, SENDA, FONASA, tratamiento drogas gratuito, centros gratuitos adicciones, 1412, rehabilitación sin costo, comunidad terapéutica gratuita Chile, residencial gratis adicciones" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://sinadicciones.org/centros-de-rehabilitacion-de-drogas-gratis" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Centros de Rehabilitación Gratis en Chile (2026) | FONASA y SENDA" />
        <meta property="og:description" content="Centros verificados financiados por SENDA y FONASA en las 16 regiones. Requisitos, cómo postular y lista actualizada." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sinadicciones.org/centros-de-rehabilitacion-de-drogas-gratis" />
        <meta property="og:image" content="https://sinadicciones.org/og-image.png" />
        <meta property="og:locale" content="es_CL" />
        <meta property="og:site_name" content="Sin Adicciones Chile" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Centros de Rehabilitación Gratis en Chile (2026) | FONASA y SENDA" />
        <meta name="twitter:description" content="Centros verificados financiados por SENDA y FONASA en las 16 regiones. Requisitos y cómo postular." />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="Sin Adicciones Chile" />
        <meta name="geo.region" content="CL" />
        <meta name="geo.placename" content="Chile" />
        
        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      

      <Header />

      {/* Hero Section with Call Button */}
      <section className="relative pt-24 pb-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/30 via-slate-900 to-slate-950" />
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-green-500/10 rounded-full blur-3xl" />
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-slate-400 mb-8">
            <Link to="/" className="hover:text-emerald-400 transition-colors flex items-center gap-1">
              <Home className="w-4 h-4" />
              Inicio
            </Link>
            <ChevronRight className="w-4 h-4" />
            <Link to="/centros-de-rehabilitacion-drogas-chile" className="hover:text-emerald-400 transition-colors">
              Centros
            </Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-emerald-400">Centros Gratuitos</span>
          </nav>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-500/10 border border-green-500/20 rounded-full mb-6">
                <Shield className="w-5 h-5 text-green-400" />
                <span className="text-green-400 font-medium">100% Gratuito vía SENDA</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Centros de Rehabilitación de Drogas{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                  Gratis en Chile
                </span>
              </h1>
              
              <p className="text-lg md:text-xl text-slate-300 mb-2">
                <strong>¿Buscas tratamiento gratis para adicciones en Chile?</strong>
              </p>
              <p className="text-base md:text-lg text-slate-300 mb-8 leading-relaxed">
                En Chile, &quot;gratis&quot; significa <strong className="text-emerald-300">financiado por el Estado</strong>: programas SENDA cubiertos por <strong>FONASA</strong> (tramos A, B, C y D), centros conveniados con la red pública y fundaciones sin fines de lucro. Más abajo te explicamos los <a href="#requisitos" className="text-emerald-400 hover:underline">requisitos paso a paso</a> y la lista actualizada por región.
              </p>

              {/* Main CTA - Call 1412 */}
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="tel:1412"
                  className="flex items-center justify-center gap-3 px-8 py-5 bg-green-500 hover:bg-green-600 text-white font-bold rounded-2xl transition-all shadow-lg shadow-green-500/30 text-lg group"
                  data-testid="call-1412-hero"
                >
                  <Phone className="w-6 h-6 group-hover:animate-pulse" />
                  <span>Llamar al 1412</span>
                  <span className="text-green-200 text-sm">(Gratis 24/7)</span>
                </a>
                <Link 
                  to="/centros-de-rehabilitacion-drogas-chile"
                  className="flex items-center justify-center gap-2 px-6 py-5 bg-slate-800 hover:bg-slate-700 text-white font-semibold rounded-2xl transition-all border border-slate-700"
                >
                  <Building2 className="w-5 h-5" />
                  Ver Todos los Centros
                </Link>
              </div>
            </div>

            {/* Stats Card */}
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-3xl p-8 border border-slate-700">
              <h2 className="text-2xl font-bold text-white mb-6">Cifras en Chile</h2>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center p-4 bg-slate-900/50 rounded-xl">
                  <p className="text-4xl font-bold text-green-400">100+</p>
                  <p className="text-slate-400 text-sm mt-1">Programas Gratuitos</p>
                </div>
                <div className="text-center p-4 bg-slate-900/50 rounded-xl">
                  <p className="text-4xl font-bold text-green-400">3.000+</p>
                  <p className="text-slate-400 text-sm mt-1">Cupos Mensuales RM</p>
                </div>
                <div className="text-center p-4 bg-slate-900/50 rounded-xl">
                  <p className="text-4xl font-bold text-green-400">16</p>
                  <p className="text-slate-400 text-sm mt-1">Regiones Cubiertas</p>
                </div>
                <div className="text-center p-4 bg-slate-900/50 rounded-xl">
                  <p className="text-4xl font-bold text-green-400">24/7</p>
                  <p className="text-slate-400 text-sm mt-1">Atención Fono 1412</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How to Access - Accordion Style */}
      <section id="requisitos" className="py-16 bg-slate-900/50 scroll-mt-24">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-4">
            Requisitos y cómo postular a un centro gratuito
          </h2>
          <p className="text-slate-400 text-center mb-10 max-w-2xl mx-auto">
            Pasos verificados para acceder a rehabilitación financiada por SENDA y cubierta por FONASA (tramos A, B, C y D).
          </p>

          <div className="space-y-4">
            <InfoAccordion title="Paso 1: Llama al Fono Drogas y Alcohol 1412" defaultOpen={true}>
              <div className="space-y-4">
                <p>
                  El <strong>Fono 1412</strong> es tu primer punto de contacto. Es un servicio <strong>gratuito, confidencial y disponible 24/7</strong>.
                </p>
                <ul className="list-disc list-inside space-y-2 text-slate-300">
                  <li>Te orientan sobre tu situación personal</li>
                  <li>Te guían hacia el centro más cercano</li>
                  <li>Te explican los requisitos y documentos necesarios</li>
                  <li>Priorizan casos de urgencia</li>
                </ul>
                <a 
                  href="tel:1412"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-xl transition-all mt-4"
                >
                  <Phone className="w-5 h-5" />
                  Llamar Ahora al 1412
                </a>
              </div>
            </InfoAccordion>

            <InfoAccordion title="Paso 2: Acude a tu CESFAM más cercano">
              <div className="space-y-4">
                <p>
                  Después de la orientación telefónica, dirígete al <strong>Centro de Salud Familiar (CESFAM)</strong> o consultorio más cercano a tu domicilio.
                </p>
                <h4 className="font-semibold text-white mt-4">Requisitos:</h4>
                <ul className="list-disc list-inside space-y-2 text-slate-300">
                  <li>Ser mayor de 18 años (o con tutor para menores)</li>
                  <li>Estar afiliado a FONASA</li>
                  <li>Llevar cédula de identidad</li>
                  <li>No necesitas derivación previa si vas por demanda espontánea</li>
                </ul>
                <p className="text-sm text-slate-400 mt-4">
                  Tiempo aproximado de espera: 1-2 semanas para la primera cita.
                </p>
              </div>
            </InfoAccordion>

            <InfoAccordion title="Paso 3: Evaluación y Derivación">
              <div className="space-y-4">
                <p>
                  Un profesional de la dupla psicosocial (psicólogo y trabajador social) realizará una evaluación gratuita para determinar el tipo de tratamiento que necesitas.
                </p>
                <h4 className="font-semibold text-white mt-4">Tipos de programa:</h4>
                <ul className="list-disc list-inside space-y-2 text-slate-300">
                  <li><strong>Ambulatorio:</strong> Asistes varias veces por semana sin internación</li>
                  <li><strong>Residencial:</strong> Internación completa con alojamiento incluido</li>
                  <li><strong>Intensivo:</strong> Para casos que requieren mayor contención</li>
                </ul>
              </div>
            </InfoAccordion>

            <InfoAccordion title="Paso 4: Inicia el Tratamiento">
              <div className="space-y-4">
                <p>
                  Una vez evaluado, serás derivado a uno de los centros de la red SENDA. El tratamiento es <strong>completamente gratuito</strong> e incluye:
                </p>
                <ul className="list-disc list-inside space-y-2 text-slate-300">
                  <li>Terapias individuales y grupales</li>
                  <li>Atención psiquiátrica si es necesario</li>
                  <li>Apoyo familiar</li>
                  <li>Seguimiento post-egreso</li>
                  <li>Medicamentos (en programas residenciales)</li>
                </ul>
                <p className="text-sm text-slate-400 mt-4">
                  Duración típica: 3 a 12 meses según el caso.
                </p>
              </div>
            </InfoAccordion>

            <InfoAccordion title="¿Qué programas existen por región?">
              <div className="space-y-4">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-slate-700">
                        <th className="text-left py-2 text-emerald-400">Región</th>
                        <th className="text-left py-2 text-emerald-400">Programas</th>
                        <th className="text-left py-2 text-emerald-400">Modalidad</th>
                      </tr>
                    </thead>
                    <tbody className="text-slate-300">
                      <tr className="border-b border-slate-800">
                        <td className="py-2">Metropolitana</td>
                        <td className="py-2">45+ centros</td>
                        <td className="py-2">Ambulatorio y Residencial</td>
                      </tr>
                      <tr className="border-b border-slate-800">
                        <td className="py-2">Valparaíso</td>
                        <td className="py-2">12+ centros</td>
                        <td className="py-2">Ambulatorio y Residencial</td>
                      </tr>
                      <tr className="border-b border-slate-800">
                        <td className="py-2">Biobío</td>
                        <td className="py-2">15+ centros</td>
                        <td className="py-2">Ambulatorio y Residencial</td>
                      </tr>
                      <tr className="border-b border-slate-800">
                        <td className="py-2">Maule</td>
                        <td className="py-2">32 programas</td>
                        <td className="py-2">Adultos y Adolescentes</td>
                      </tr>
                      <tr>
                        <td className="py-2">Antofagasta</td>
                        <td className="py-2">19 centros</td>
                        <td className="py-2">Todas las modalidades</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </InfoAccordion>

            <InfoAccordion title="Documentos necesarios">
              <div className="space-y-4">
                <ul className="list-disc list-inside space-y-2 text-slate-300">
                  <li><strong>Cédula de identidad</strong> vigente</li>
                  <li><strong>Credencial FONASA</strong> (puedes verificar en fonasa.cl)</li>
                  <li><strong>Derivación judicial</strong> (solo si vienes de tribunales)</li>
                  <li><strong>Informe médico</strong> (si tienes condiciones de salud asociadas)</li>
                </ul>
                <p className="text-sm text-slate-400 mt-4">
                  Si no tienes todos los documentos, el CESFAM puede ayudarte a obtenerlos.
                </p>
              </div>
            </InfoAccordion>
          </div>
        </div>
      </section>

      {/* SENDA Regional Offices Section */}
      <section className="py-16 bg-slate-900/50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full text-blue-400 text-sm mb-4">
              <Building2 className="w-4 h-4" />
              Oficinas SENDA en Chile
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Direcciones Regionales SENDA
            </h2>
            <p className="text-slate-400 max-w-2xl mx-auto">
              SENDA cuenta con oficinas en cada región del país. Estas direcciones te permiten acceder a orientación y derivación a centros de rehabilitación gratuitos.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {(showAllRegionales ? direccionesRegionales : direccionesRegionales.slice(0, 6)).map((oficina, idx) => (
              <div key={idx} className="p-5 bg-slate-800/50 rounded-xl border border-slate-700 hover:border-blue-500/50 transition-all">
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="font-bold text-white text-lg">{oficina.region}</h4>
                    <p className="text-slate-500 text-sm">{oficina.director}</p>
                  </div>
                  {oficina.email && (
                    <a href={`mailto:${oficina.email}`} className="p-2 bg-blue-500/10 text-blue-400 rounded-lg hover:bg-blue-500/20 transition-colors">
                      <Mail className="w-5 h-5" />
                    </a>
                  )}
                </div>
                <div className="mt-3 space-y-2">
                  <div className="flex items-start gap-2 text-slate-300 text-sm">
                    <MapPin className="w-4 h-4 mt-0.5 text-emerald-400 flex-shrink-0" />
                    {oficina.direccion}
                  </div>
                  {oficina.telefono && (
                    <a href={`tel:${oficina.telefono.replace(/[^0-9]/g, '')}`} className="flex items-center gap-2 text-slate-300 text-sm hover:text-emerald-400">
                      <Phone className="w-4 h-4" />
                      {oficina.telefono}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>

          {direccionesRegionales.length > 6 && (
            <div className="text-center mt-6">
              <button 
                onClick={() => setShowAllRegionales(!showAllRegionales)}
                className="inline-flex items-center gap-2 px-6 py-3 bg-slate-800 hover:bg-slate-700 text-white rounded-xl transition-colors"
              >
                {showAllRegionales ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                {showAllRegionales ? 'Ver menos' : `Ver las ${direccionesRegionales.length} regiones`}
              </button>
            </div>
          )}
        </div>
      </section>

      {/* SENDA Previene Section */}
      <section className="py-16 bg-slate-950">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full text-emerald-400 text-sm mb-4">
              <Users className="w-4 h-4" />
              En tu comuna
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Oficinas SENDA Previene
            </h2>
            <p className="text-slate-400 max-w-2xl mx-auto">
              Las oficinas SENDA Previene están ubicadas en municipios de todo Chile. Ofrecen prevención, orientación y derivación a tratamientos gratuitos directamente en tu comuna.
            </p>
          </div>

          {/* Region Filter */}
          <div className="flex justify-center mb-8">
            <select 
              value={selectedRegion} 
              onChange={(e) => setSelectedRegion(e.target.value)}
              className="bg-slate-800 border border-slate-700 text-white rounded-xl px-4 py-3 focus:border-emerald-500 focus:outline-none min-w-64"
            >
              {regiones.map(r => (
                <option key={r} value={r}>{r === 'todas' ? 'Todas las regiones' : r}</option>
              ))}
            </select>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {(showAllPreviene ? filteredPreviene : filteredPreviene.slice(0, 9)).map((oficina, idx) => (
              <div key={idx} className="p-4 bg-slate-800/30 rounded-lg border border-slate-700/50 hover:border-emerald-500/30 transition-all">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h4 className="font-semibold text-white">{oficina.comuna}</h4>
                    <p className="text-slate-500 text-xs">{oficina.region}</p>
                  </div>
                  {oficina.email && (
                    <a href={`mailto:${oficina.email}`} className="text-emerald-400 hover:text-emerald-300">
                      <Mail className="w-4 h-4" />
                    </a>
                  )}
                </div>
                <div className="text-slate-400 text-sm flex items-start gap-1">
                  <MapPin className="w-3 h-3 mt-1 flex-shrink-0" />
                  <span className="line-clamp-1">{oficina.direccion}</span>
                </div>
                {oficina.telefono && (
                  <a href={`tel:${oficina.telefono.replace(/[^0-9]/g, '')}`} className="text-slate-400 text-sm mt-1 flex items-center gap-1 hover:text-emerald-400">
                    <Phone className="w-3 h-3" />
                    {oficina.telefono}
                  </a>
                )}
              </div>
            ))}
          </div>

          {filteredPreviene.length > 9 && (
            <div className="text-center mt-6">
              <button 
                onClick={() => setShowAllPreviene(!showAllPreviene)}
                className="inline-flex items-center gap-2 px-6 py-3 bg-slate-800 hover:bg-slate-700 text-white rounded-xl transition-colors"
              >
                {showAllPreviene ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                {showAllPreviene ? 'Ver menos' : `Ver todas las ${filteredPreviene.length} oficinas`}
              </button>
            </div>
          )}

          <div className="p-6 bg-blue-900/20 rounded-xl border border-blue-500/30 mt-8 text-center">
            <p className="text-slate-300">
              <strong className="text-blue-400">Nota:</strong> Estas son algunas de las oficinas SENDA Previene. Para ver el listado completo de más de 300 oficinas en todo Chile, visita{" "}
              <a href="https://www.senda.gob.cl/quienes-somos/encuentranos/" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:underline inline-flex items-center gap-1">
                senda.gob.cl/encuentranos
                <ExternalLink className="w-4 h-4" />
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Centers Listing */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Centros de Rehabilitación en Chile
            </h2>
            <p className="text-slate-400 max-w-2xl mx-auto">
              Explora nuestra base de datos de centros. Muchos ofrecen convenios con FONASA o programas gratuitos.
            </p>
          </div>

          {loading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="bg-slate-800/50 rounded-2xl p-6 animate-pulse">
                  <div className="h-40 bg-slate-700 rounded-xl mb-4" />
                  <div className="h-6 bg-slate-700 rounded w-3/4 mb-2" />
                  <div className="h-4 bg-slate-700 rounded w-1/2" />
                </div>
              ))}
            </div>
          ) : (
            <>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {centers.map((center) => (
                  <Link
                    key={center.center_id}
                    to={`/centros/${center.slug || center.center_id}`}
                    className="group bg-slate-800/50 rounded-2xl overflow-hidden border border-slate-700 hover:border-emerald-500/50 transition-all"
                  >
                    <div className="aspect-video bg-slate-700 relative overflow-hidden">
                      {(() => {
                        const rawImg = center.logo || (center.gallery && center.gallery[0]) || (center.images && center.images[0]);
                        const imgUrl = getImageUrl(rawImg);
                        return imgUrl ? (
                          <img 
                            src={imgUrl} 
                            alt={center.name}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center">
                            <Building2 className="w-16 h-16 text-slate-600" />
                          </div>
                        );
                      })()}
                      {center.is_premium && (
                        <span className="absolute top-3 left-3 px-2 py-1 bg-amber-500 text-white text-xs font-semibold rounded">
                          Premium
                        </span>
                      )}
                      {center.is_verified && (
                        <span className="absolute top-3 right-3 px-2 py-1 bg-emerald-500 text-white text-xs font-semibold rounded flex items-center gap-1">
                          <CheckCircle className="w-3 h-3" />
                          Verificado
                        </span>
                      )}
                    </div>
                    <div className="p-5">
                      <h3 className="font-bold text-white text-lg mb-2 group-hover:text-emerald-400 transition-colors line-clamp-1">
                        {center.name}
                      </h3>
                      <div className="flex items-center gap-2 text-slate-400 text-sm mb-3">
                        <MapPin className="w-4 h-4" />
                        <span>{center.city || center.region || "Chile"}</span>
                      </div>
                      {center.rating && (
                        <div className="flex items-center gap-1 text-amber-400 text-sm mb-3">
                          <Star className="w-4 h-4 fill-current" />
                          <span>{center.rating}</span>
                          {center.review_count && (
                            <span className="text-slate-500">({center.review_count})</span>
                          )}
                        </div>
                      )}
                      <div className="flex items-center gap-2 text-sm">
                        <span className="px-2 py-1 bg-slate-700 text-slate-300 rounded text-xs">
                          {center.modality || "Residencial"}
                        </span>
                        {center.price_range && (
                          <span className="px-2 py-1 bg-green-500/20 text-green-400 rounded text-xs">
                            {center.price_range}
                          </span>
                        )}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              <div className="text-center mt-10">
                <Link 
                  to="/centros-de-rehabilitacion-drogas-chile"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-xl transition-all"
                >
                  Ver Todos los Centros
                  <ArrowRight className="w-5 h-5" />
                </Link>
              </div>
            </>
          )}
        </div>
      </section>

      {/* Centros por Ciudad y Región (SEO interno · exact match anchors) */}
      <CentersByLocationLinks variant="gratis" testId="gratis-centers-by-location" />

      {/* Contenido único — Diferencias y proceso completo (2026) */}
      <section className="py-14 md:py-20 bg-slate-900/40 border-t border-slate-800/60">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="mb-10 max-w-3xl">
            <span className="inline-block px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 text-xs font-semibold uppercase tracking-wider mb-3">
              Guía 2026
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 tracking-tight">
              Qué incluye un tratamiento gratuito en Chile y qué no
            </h2>
            <p className="text-slate-400">
              Un análisis honesto de lo que cubre el sistema público vs. lo que tendrás que considerar fuera de SENDA y FONASA.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-6">
              <h3 className="text-lg font-semibold text-emerald-300 mb-3 flex items-center gap-2">
                <CheckCircle className="w-5 h-5" /> Lo que SÍ incluye gratis (SENDA / FONASA)
              </h3>
              <ul className="space-y-2 text-sm text-slate-300 leading-relaxed">
                <li>• Evaluación clínica con psiquiatra y psicólogo/a</li>
                <li>• Plan de tratamiento individual (PAI, residencial corta/larga, comunidad terapéutica)</li>
                <li>• Psicoterapia individual y grupal durante todo el programa</li>
                <li>• Atención médica para desintoxicación si la requieres</li>
                <li>• Programas específicos para mujeres embarazadas, adolescentes y patología dual</li>
                <li>• Seguimiento post-alta de al menos 6 meses</li>
              </ul>
            </div>
            <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-6">
              <h3 className="text-lg font-semibold text-amber-300 mb-3 flex items-center gap-2">
                <ChevronRight className="w-5 h-5" /> Lo que tendrás que considerar
              </h3>
              <ul className="space-y-2 text-sm text-slate-300 leading-relaxed">
                <li>• <strong>Lista de espera</strong>: 2-8 semanas para residencial, días para ambulatorio</li>
                <li>• <strong>Centro asignado</strong>: lo elige SENDA según oferta regional, no eliges tú</li>
                <li>• <strong>Traslados</strong>: si el centro queda lejos, costos los asume la familia</li>
                <li>• <strong>Gastos personales</strong> ("mascota"): $10.000-$50.000/semana en residencial</li>
                <li>• <strong>Medicamentos</strong>: cubiertos si están en el arsenal FONASA; algunos requieren copago</li>
                <li>• <strong>ISAPRE</strong>: si tienes ISAPRE, deberás verificar cobertura GES/CAEC para adicciones</li>
              </ul>
            </div>
          </div>

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            <Link to="/calculadora" className="block p-5 rounded-xl bg-slate-900 border border-slate-800 hover:border-emerald-500/60 transition">
              <div className="text-xs text-emerald-300 font-semibold uppercase tracking-wider mb-1">Herramienta</div>
              <div className="font-medium text-slate-100">Calcula el costo de un centro privado →</div>
              <p className="text-sm text-slate-400 mt-1">Útil si la espera SENDA es larga y necesitas comparar.</p>
            </Link>
            <Link to="/como-ayudar-a-un-familiar-con-adiccion" className="block p-5 rounded-xl bg-slate-900 border border-slate-800 hover:border-emerald-500/60 transition">
              <div className="text-xs text-emerald-300 font-semibold uppercase tracking-wider mb-1">Para familias</div>
              <div className="font-medium text-slate-100">¿Buscas ayuda para un familiar? →</div>
              <p className="text-sm text-slate-400 mt-1">Test de 7 preguntas + guía para hablarle sin que se cierre.</p>
            </Link>
          </div>
        </div>
      </section>

      {/* Floating Call Button */}
      <a
        href="tel:1412"
        className="fixed bottom-24 right-6 z-40 flex items-center gap-3 px-6 py-4 bg-green-500 hover:bg-green-600 text-white font-bold rounded-full shadow-lg shadow-green-500/30 transition-all hover:scale-105"
        data-testid="floating-call-1412"
      >
        <Phone className="w-6 h-6 animate-pulse" />
        <span className="hidden sm:inline">Llamar 1412</span>
      </a>

      {/* Final CTA Section */}
      <section className="py-16 bg-gradient-to-t from-green-900/20 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <Heart className="w-16 h-16 text-green-400 mx-auto mb-6" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            La Ayuda Está a Una Llamada de Distancia
          </h2>
          <p className="text-slate-300 mb-8 max-w-2xl mx-auto">
            El <strong>Fono Drogas y Alcohol 1412</strong> es gratuito, confidencial y está disponible las 24 horas del día, los 7 días de la semana. 
            No estás solo en esto.
          </p>
          
          <a 
            href="tel:1412"
            className="inline-flex items-center gap-4 px-10 py-6 bg-green-500 hover:bg-green-600 text-white font-bold rounded-2xl transition-all shadow-xl shadow-green-500/30 text-xl"
          >
            <Phone className="w-8 h-8" />
            <div className="text-left">
              <span className="block">Llamar al 1412</span>
              <span className="text-green-200 text-sm font-normal">Gratis · Confidencial · 24/7</span>
            </div>
          </a>

          <div className="mt-8 flex flex-wrap justify-center gap-6 text-sm text-slate-500">
            <span className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-400" />
              Atención profesional
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-400" />
              100% gratuito
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-400" />
              Confidencial
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-400" />
              Sin lista de espera
            </span>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CentrosRehabilitacionDrogasGratisLanding;
